import type {ExtractPropsWithoutRef} from '@/types';

import {Flex, HeadlineSmall} from '@travel-frontend/ui-components';

import {CountBadge} from '@/components/CountBadge';
import {HelpTooltip} from '@/components/HelpTooltip';

type Props = ExtractPropsWithoutRef<'div'> &
  React.PropsWithChildren<{
    caption: React.ReactNode;
    selectedFiltersCount?: number;
    helpArticle?: React.ReactNode;
  }>;

export const FilterTile = ({
  caption,
  children,
  selectedFiltersCount,
  helpArticle,
  ...restProps
}: Props) => {
  return (
    <Flex {...restProps} spacing="8px">
      <HeadlineSmall>
        <Flex
          direction="row"
          alignItems="center"
          spacing="8px"
          data-testid="caption"
        >
          {caption}
          {helpArticle && (
            <HelpTooltip placement="bottom" content={helpArticle} />
          )}
          {selectedFiltersCount && <CountBadge count={selectedFiltersCount} />}
        </Flex>
      </HeadlineSmall>
      <div>{children}</div>
    </Flex>
  );
};
